import ActBtn from 'components/buttons/ActBtn'
import { Col, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import {  useRef } from 'react'
import { useAccount } from 'state/Account'
import { useServerConstants } from 'state/Constants'
import { useActiveRestaurant } from 'state/Restaurants'
import { useState } from 'react'

/**
 * Displays a warning modal when third party delivery is switched off in eHungry admin (and a modal when it's switched back on)
 * @returns {JSX.Element}
 * @constructor
 */
export default function ThirdPartyDisabledModal() {

	const { t } = useTranslation()
	const activeRest = useActiveRestaurant()
	const account = useAccount()
	const prevShipdayGloballyDisabled = useRef(account.shipday_globally_disabled)
	const CONSTANTS = useServerConstants()
	const isShipdayOn = account.isShipdayOn(CONSTANTS.VALUES)
	const [showModal, setShowModal] = useState(false)

	if (isShipdayOn && account.shipday_globally_disabled !== undefined) {
		//Show the modal on login and when shipday_globally_disabled changes
		if ((!JSON.parse(sessionStorage.getItem('thirdPartyModalShown')) && account.shipday_globally_disabled)
			|| (prevShipdayGloballyDisabled.current !== undefined && prevShipdayGloballyDisabled.current !== account.shipday_globally_disabled)) {
			setShowModal(true)
			//To show the modal only once
			sessionStorage.setItem('thirdPartyModalShown', JSON.stringify(true))
		}
		//Keep the previous state of shipday_globally_disabled to know when it changes
		prevShipdayGloballyDisabled.current = account.shipday_globally_disabled
	}

	async function doClose() {
		setShowModal(false)
	}

	return <Modal show={showModal} backdrop="static" size="md">
		<Modal.Header>
			<Modal.Title>{t('Third-party delivery') + ' ' + (account?.shipday_globally_disabled? 'disabled' : 'enabled')}</Modal.Title>
		</Modal.Header>
		<Modal.Body>{account?.shipday_globally_disabled?
			(activeRest !== undefined && activeRest?.shipday_auto_dispatch_enabled?
			t('Oops, our third-party delivery service is experiencing a server issue, so we’ve temporarily turned off delivery ordering. If you can handle delivery orders with in-house drivers, please switch off “auto-dispatching.” For assistance, contact our support team. Thanks!')
			: t('Oops, our third-party delivery service is having a server issue. We’re working to resolve it quickly. In the meantime, please use your in-house drivers or disable delivery ordering from the Manager App if needed. For help, contact our support team. Thanks!')
			):
			t('Our third-party delivery service is back to normal! If you encounter any issues, contact our support team. Thanks!')
		}</Modal.Body>
		<Modal.Footer as={Row}>
			<Col sm="auto">
				<ActBtn block variant={account?.shipday_globally_disabled? 'danger' : 'success'} texts={[t('Confirm'), t('Confirming')]} action={doClose}/>
			</Col>
		</Modal.Footer>
	</Modal>
}
